// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__TFrf0","statusCode":"Error_statusCode__CmGmv","title":"Error_title___FNxn","description":"Error_description__PH70j","action":"Error_action__GGiJV"};